import HighlightText from './HighlightText';

export default HighlightText;
